<div class="modal active createProj">
  <div class="modal__container modal__container--sm">
      <div class="fields">
          <h2 *ngIf="!editMode">Create Project</h2>
          <h2 *ngIf="editMode">Edit Project</h2>
          <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
          <div class="fields__container">
              <form autocomplete="off"  [formGroup]="projectForm" class="active" (ngSubmit)="saveProject()">
                  <div class="fields__block">
                      <div class="fields__block__section">
                          <div class="input-fields">
                              <div>
                                <label for="">Name</label>
                                <input name="name" type="text" formControlName="name" (input)="validateProjectName($event)" [(ngModel)]="project.name" maxlength="30" [attr.disabled] = "editMode ? 'disabled' : null"/>
                                <label *ngIf="nameExist" style="color: red;">Already exist a project with this name.</label>
                              </div>
                              <div><label for="">Description</label><input name="decription" type="text" formControlName="description" [(ngModel)]="project.description" maxlength="30"/></div>
                              <div *ngIf="!this.projectService.importMode" style="display: none"><label for="">Configuration</label>
                                <select name="configurations" formControlName="configuration" [attr.disabled] = "editMode ? 'disabled' : null" [(ngModel)]="project.configurationID">
                                  <option value="1">Default</option>
                                  <option value="2">Void</option>
                                </select>
                              </div>

                              <div [ngStyle]="{'display': editMode ? 'none' : 'flex' }">
                                <label for="">Originator</label>
                                <select name="originator" formControlName="originator">
                                  <option *ngFor="let group of gritUserService.getRoleGroupsPaths(GritUserRoleGroup.FullUser)"
                                          [value]="group">{{group}}
                                  </option>
                                </select>
                              </div>

                          </div>
                      </div>
                  </div>
                  <div class="fields__btn">
                    <button type="submit" [ngClass]="projectForm.valid && !nameExist ? 'blue' : 'gray'" (click)="saveProject();  projectForm.reset()" [disabled]="!projectForm.valid || nameExist">Save</button>
                    <a class="gray" href="#" type="reset" value="Cancel" (click)="cancel()">Cancel</a>
                  </div>
              </form>
          </div>
      </div>
  </div>
</div>
